<template>
	<div id="content" class="flex ">
                <!-- ############ Main START-->
                <div>
                	<!--
                    <div class="page-hero page-container " id="page-hero">
                        <div class="padding d-flex">
                            <div class="page-title">
	                            <a href="index.html"><button class="btn btn-light"><arrow-left-icon width="16" height="16"></arrow-left-icon> Back to all leads</button></a>
                            </div>
                        </div>
                    </div>
                	-->
                    <div class="page-content page-container" id="page-content">
                        <div class="padding">
                            <div class="card">
                                <div class="card-header bg-dark bg-img p-0 no-border" data-stellar-background-ratio="0.1" style="background-image:url(../../static/assets/img/b1.jpg);">
                                    <div class="bg-dark-overlay r-2x no-r-b">
                                        <div class="d-md-flex">
                                            <div class="p-4">
                                                <div class="d-flex">
                                                    <span class="avatar w-64">
              											<CompanyLogo class="avatar w-64" :domain="company.domain"></CompanyLogo>
                                                        <!-- <i class="on"></i> -->
            										</span>
                                                    <div class="mx-3">
                                                        <h5 class="mt-2">{{company.name}}</h5>
                                                        <div class="text-fade text-sm">
                                                            <small>
                                                                <span><a style="color:silver" :href="'http://' + company.domain">{{company.domain}}</a></span>
                                                                <i class="fa fa-map-marker mr-2"></i>{{company.country}}</small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <span class="flex"></span>
                                            <div class="align-items-center d-flex p-4">
                                                <div class="toolbar">
                                                    <a href="#" class="btn btn-sm bg-dark-overlay btn-rounded text-white bg-success active" data-toggle-class="bg-success">
                                                        <span class="d-inline">Follow</span>
                                                        <span class="d-none">Following</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="p-3">
                                    <div class="d-flex">
                                        <ul class="nav nav-pills">
                                            <li class="nav-item mr-1">
                                                <a class="nav-link active" href="#" data-toggle="tab" data-target="#tab_1">People inside {{company.name}}</a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" href="#" data-toggle="tab" data-target="#tab_2">Activity</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-7 col-lg-8">
                                    <div class="tab-content">
                                        <div class="tab-pane fade show active" id="tab_1">
                                            <div class="table-responsive">
			                                    <table class="table table-theme table-row v-middle">
			                                        <thead>
			                                            <tr>
			                                                <th style="width:20px;">
			                                                    <label class="ui-check m-0">
			                                                        <input type="checkbox">
			                                                        <i></i>
			                                                    </label>
			                                                </th>
			                                                <th class="text-muted">Owner</th>
			                                                <th class="text-muted sortable" data-toggle-class="asc">People</th>
			                                                <!--<th class="text-muted"><span class="d-none d-sm-block">Location</span></th>-->
			                                                <th class="text-muted"><span class="d-none d-sm-block">Email</span></th>
			                                                <th style="width:50px;"></th>
			                                            </tr>
			                                        </thead>
			                                        <tbody>
			                                            <tr class=" v-middle" data-id="6" v-for="(employee, index) in displayedItems">
			                                                <td>
			                                                    <label class="ui-check m-0 ">
			                                                        <input type="checkbox" name="id" value="6">
			                                                        <i></i>
			                                                    </label>
			                                                </td>
			                                                <td>
			                                                    <div class="d-flex avatar-group">
			                                                        <a href="#" class="avatar w-32" data-toggle="tooltip" title="Velit,">
			                                                            <img src="../../static/assets/img/a3.jpg" alt=".">
			                                                        </a>
			                                                    </div>
			                                                </td>
			                                                <td class="flex">
			                                                    <a href="#" class="item-title text-color ">{{employee.name}}</a>
			                                                    <div class="item-except text-muted text-sm h-1x">
			                                                        {{employee.role}}
			                                                    </div>
			                                                </td>
                                                            <!--
			                                                <td>
			                                                    <span class="item-amount d-none d-sm-block text-sm ">
											                        Ankara, Turkey
											                    </span>
			                                                </td>-->
			                                                <td>
			                                                    <span class="item-amount d-none d-sm-block text-sm [object Object]">
											                        <span class="blur-text">{{employee.email}}</span>
											                    </span>
			                                                </td>
			                                                <td>
			                                                    <button class="btn w-sm mb-1 btn-warning"><lock-icon width="16" height="16">Unlock</lock-icon></button>
			                                                </td>
			                                            </tr>
			                                        </tbody>
			                                    </table>
			                                </div>
                                            <Paginate :pageCount="pageCount"
                                                    v-model="currentPage"
                                                    :containerClass="'pagination'">
                                            </Paginate>
                                        </div>
                                        <div class="tab-pane fade" id="tab_2">
                                            <div class="card p-4">
                                                <div class="timeline animates animates-fadeInUp">
                                                    <div class="tl-item  active">
                                                        <div class="tl-dot ">
                                                        </div>
                                                        <div class="tl-content">
                                                            <div class="">AI will deliver adaptive learning processes in assessments & digital textbooks to personalize learning</div>
                                                            <div class="tl-date text-muted mt-1">13/12 18</div>
                                                        </div>
                                                    </div>
                                                    <div class="tl-item  ">
                                                        <div class="tl-dot ">
                                                        </div>
                                                        <div class="tl-content">
                                                            <div class="">Big News! Introducing
                                                                <a href='#'>NextUX</a> Enterprise 2.1 - additional #Windows Server support</div>
                                                            <div class="tl-date text-muted mt-1">2 hours ago</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-5 col-lg-4">
                                    <div class="card sticky" style="z-index: 1">
                                                <div class="px-4 py-4">
                                                    <div class="row mb-2">
                                                        <div class="col-6">
                                                            <small class="text-muted">Industry</small>
                                                            <div class="my-2">{{company.industry}}</div>
                                                        </div>
                                                        <div class="col-6">
                                                            <small class="text-muted">Employees</small>
                                                            <div class="my-2">{{company.numberofemployees}}</div>
                                                        </div>
                                                    </div>
                                                    <div class="row mb-2">
                                                        <div class="col-6">
                                                            <small class="text-muted">Location</small>
                                                            <div class="my-2">{{company.location}}</div>
                                                        </div>
                                                        <div class="col-6">
                                                            <small class="text-muted">Phone Number</small>
                                                            <div class="my-2">{{company.phone_number}}</div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <small class="text-muted">Description</small>
                                                        <div class="my-2">{{company.description}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- ############ Main END-->
            </div>
</template>


<script type="text/javascript">
import { ArrowLeftIcon, LockIcon} from 'vue-feather-icons';
import Paginate from 'vuejs-paginate';
import ScrollReveal from "../../static/libs/scrollreveal/dist/scrollreveal.min.js";

import CompanyLogo from "@/components/CompanyLogo";

export default{
	name: 'CompanyProfile',
	components:{
		ArrowLeftIcon,
		LockIcon,
        Paginate,
        CompanyLogo
	},
	data() {
		return {
			company: '',
            currentPage: 1,
            pageSize: 10,
		}; 
	},
    computed: {
      displayedItems() {
        var employees = this.company['employees'] || [];

        return this.paginate(employees, this.currentPage, this.pageSize);
      },
      pageCount() {
        var employees = this.company['employees'] || [];
        return Math.ceil(employees.length/this.pageSize);
      },
    },

    methods:{
        paginate(items, currentPage, pageSize) {       
            var begin = (currentPage-1)*pageSize;
            var end = Math.min(begin + pageSize, items.length);

            return items.slice(begin, end);
          },

        onPageChange(page) {
            this.$emit('pagechange', page);
        },
    },

	activated(){
        this.company = {};
        this.currentPage = 1;
		let company_id = this.$route.params['id'];
		let company_name = this.$route.params['name'];
		const path = process.env.API_LOCATION + `/company_profile/${company_id}/${company_name}`;

        var that = this;

		this.$http.get(path)
        .then((res) => {
            that.company = res.data.company;
            console.log("Company profile loaded successfully.");
            console.log(res);
        })
        .catch((error) => {
            console.log("Error while loading company profile.");
            console.error(error);   
        });
    },
};  

</script>



// WEBPACK FOOTER //
// src/components/CompanyProfile.vue